import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { GridRow, GridColumn, Grid, Dropdown, DropdownProps, Button, Icon } from "semantic-ui-react";

import styles from "./DartsScoring.module.scss";
import * as _thunk from "./DartsScoring.thunk";
import { syncDartsGameIdType } from "./DartsScoring.slice";
import { DartsGameStatusPayload } from "./DartsScoring.types";
import { headerHeight } from "./DartsScoring.const"

import Orientation from "../../../helpers/Orientation.helper";
import DartBoard from "../../../components/Darts/Board/DartBoard";
import DartsScoringTracker from "./Tracker/DartsScoringTracker";
import DartsScoringTimelines from "./Timelines/DartsScoringTimelines";
import { useAppDispatch } from "../../../hooks/hooks";
import { useAppSelector } from "../../../hooks/hooks";
import DimmerLoader from "../../../components/DimmerLoader/DimmerLoader";
import IDartsGameIdType from "../../../common/interfaces/IDartsGameIdType";
import { initDartsGameScoring, setDartsGameStatus } from "./DartsScoring.thunk";
import { StringToDartsGameType } from "../../../helpers/Mappers.helper";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { DartsGameStatus, DartsGameStatusesForScoring } from "../../../common/types/DartsGameStatuses";

const DartsScoring = () => {
    const headerStyles: React.CSSProperties = {
        height: `${headerHeight}px`,
        maxHeight: `${headerHeight}px`
    };
    const boardHeight = Math.min(window.innerWidth * 0.9 * 10 / 16, window.innerHeight - headerHeight);
    const boardStyles: React.CSSProperties = {
        height: `${boardHeight}px`,
        maxHeight: `${boardHeight}px`
    };
    const trackerHeight = (window.innerHeight - headerHeight) / 2 - 10;
    const trackerStyles: React.CSSProperties = {
        height: `${trackerHeight}px`,
        maxHeight: `${trackerHeight}px`
    };
    const timelinesHeight = (window.innerHeight - headerHeight) / 2 - 10;
    const timelinesStyles: React.CSSProperties = {
        height: `${timelinesHeight}px`,
        maxHeight: `${timelinesHeight}px`
    };
    const btnSettingTop = headerHeight;
    const btnSettingStyles: React.CSSProperties = {
        top: `${btnSettingTop}px`,
    };
    
    const orientation = Orientation();
    const { gameType, gameId } = useParams()
    const dispatch = useAppDispatch()
    const scoring = useAppSelector(state => state.DartsScoring);
    const [loader, setLoader] = useState(false);
    const [title, setTitle] = useState('... vs ...');
    const [status, setStatus] = useState(DartsGameStatus.Undefined);


    const initGameForScoring = () => {
        let id = Number(gameId);
        let type = StringToDartsGameType(gameType);
        if (isNaN(id) || type === undefined) {
            toastr.error(COMPANY_ABBR, "Unknown game. Doblecheck game type and id.");
            return;
        }
        let payload: IDartsGameIdType = { gameId: id, gameType: type }
        console.log("DartsScoring.initGameForScoring payload: ", payload);
        dispatch(syncDartsGameIdType(payload));
        setLoader(true)
        dispatch(initDartsGameScoring(payload));
        setLoader(false)
    }

    //const boardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.title += ` - Darts Scoring`;
    });

    useEffect(() => {
        if (gameType === undefined || gameId === undefined) {
            toastr.error(COMPANY_ABBR, "Unknown game. Doblecheck game type and id.");
            return;
        }
        initGameForScoring();
    }, []);

    useEffect(() => {
        if (scoring.game && scoring.game.players && scoring.game.players.length >= 2) {
            let playerNames = scoring.game.players.map(p => p.name);
            setTitle(playerNames.join(' vs '));
        }
    }, [scoring.game.players]);

    useEffect(() => {
        console.log("DartsScoring.useEffect.scoring.game.status: ", scoring.game.status);
        if (scoring.game.status) {
            setStatus(scoring.game.status);
        }
    }, [scoring.game.status]);

    useEffect(() => {
        const handleResize = () => {
            //        if (boardRef.current) {
            //            const rect = boardRef.current.getBoundingClientRect();
            //            setWidth(rect.width);
            //            setHeight(rect.height);
            //        }
            document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const changeStatus = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
        let payload: DartsGameStatusPayload = {
            status: data.value as DartsGameStatus,
            playerId: null
        }
        dispatch(setDartsGameStatus(payload));
    }

    const undo = () => {
        dispatch(_thunk.undoLastAction());
    }

    const openSettings = () => {
        //ToDo: open modal with game settings
    }

    return (
        <>
            {orientation === "landscape" ?
                <Grid columns={2} className={styles.grid}>
                    <GridRow className={styles.title_row} style={headerStyles}>
                        <GridColumn width={10} className={styles.title_column} style={headerStyles}>
                            <p>{title}</p>
                        </GridColumn>
                        <GridColumn width={6} className={styles.status_column}>
                            <Dropdown inline options={DartsGameStatusesForScoring} value={status} icon={null} className={styles.status_dropdown} onChange={changeStatus} />
                        </GridColumn>
                    </GridRow>
                    <GridRow stretched className={styles.main_row}>
                        <GridColumn width={10}>
                            <div style={boardStyles}>
                                <DartBoard type='triple' />
                                <Button icon color="black" className={styles.btnSetting} style={btnSettingStyles} onClick={openSettings}>
                                    <Icon name='setting' color="orange" />
                                </Button>
                                <Button icon color='red' className={styles.btnUndo} onClick={undo} disabled={scoring.btnUndoDisabled}>
                                    <Icon name='undo' />
                                </Button>
                           </div>
                    </GridColumn>
                        <GridColumn width={6}>
                            <div className={styles.tableDartsScoringTracker} style={trackerStyles}>
                                <DartsScoringTracker />
                            </div>
                            <div className={styles.tableDartsScoringTimelines} style={timelinesStyles}>
                                <DartsScoringTimelines />
                            </div>
                    </GridColumn>
                </GridRow>
            </Grid>
            :
            <Grid className="grid">
                <GridRow>
                    <GridColumn width={16} className={styles.title_column}>
                        <p>{title}</p>
                    </GridColumn>
                    <GridColumn width={16}>
                        <p>portrait view component</p>
                    </GridColumn>
                    <GridColumn width={16}>
                        <DartBoard type='triple' />
                    </GridColumn>
                </GridRow>
            </Grid>
            }
            {loader &&
                <DimmerLoader />
            }
        </>
    );
}
export default DartsScoring;
DartsScoring.displayName = "Darts Scoring";

/**
 * <div ref={boardRef} id=''>
 * <DartBoard width={boardWidth} height={boardHeight} type='triple' />
 * </div>
 */